<template>
  <button
    class="btn btn-info"
    @click.prevent="add()"
  >
    <i class="fa fa-fw fa-plus mr-2" />

    <slot>Dodaj wiersz</slot>
  </button>
</template>

<script>
export default {
  name: 'WAddRow',
  props: {
    model: {
      type: Object,
      required: true
    },
    count: {
      type: Number,
      default: 1
    },
    rowDefault: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  methods: {
    add() {
      this.model.$addRow({ ...this.rowDefault }, this.count);
      this.$emit('rowAdded', this.count);
    }
  }
};
</script>
